module.exports = __webpack_public_path__ + "assets/img/kv-55735f52.jpg";